export default {
  cancelOrderMap: {
    0: "Eu não quero isso.",
    1: "perdeu o produto",
    2: "Pedido duplicado",
    3: "Falha ao receber",
    4: "Outras razões",
  },
  "获取验证码": "Obter código de verificação",
  "验证码": "Código de verificação",
  "请输入验证码": "Por favor, insira o código de verificação",
  "发送": "Enviar",
  "已发送，请注意查收":
    "Enviado, por favor, note que recebeu",
  "请选择": "Por favor escolha",
  "仅能绑定一个收款地址!": "Apenas um endereço de recebimento pode ser vinculado!",
  "绑定成功": "Vinculado com sucesso",
  "提款地址绑定": "Endereço de retirada vinculado",
  "电商批发商场": "Mercado atacadista de comércio eletrônico",
  "请输入完整的支付密码!" : "Por favor, insira a senha de pagamento completa!",
  "用户未发表评论": "O usuário não comentou",
  "订单": "Ordem",
  "备注": "Observação",
  "当前余额": "Saldo atual",
  "下单成功，等待付款": "Pedido realizado com sucesso, aguardando pagamento",
  "下单成功，付款成功": "Pedido feito com sucesso, pagamento efetuado com sucesso",
  "已发货，正在运输中": "Enviado, no transporte",
  "订单已取消，原因:手动发起取消订单": "O pedido foi cancelado. Motivo: Cancelar o pedido manualmente.",
  "订单已取消，原因:超时自动取消订单": "O pedido foi cancelado. Motivo: O pedido será cancelado automaticamente após o tempo limite.",
  "商家已确认，已进入备货状态": "O comerciante foi confirmado e entrou no estado de estoque.",
  "系统发货成功": "A entrega do sistema foi bem-sucedida",
  "订单已签收": "Pedido Recebido",
  "发起退款申请": "Iniciar uma solicitação de reembolso",
  "退款成功": "Reembolso bem-sucedido",
  "退款失败": "Falha no reembolso",
  "订单退款成功": "Reembolso do pedido com sucesso",
  "订单退款失败": "Falha no reembolso do pedido",
  "系统默认好评": "O sistema padroniza para avaliações favoráveis",
  "请输入关键字搜索": "Por favor, insira a palavra-chave para pesquisar",
  "猜你喜欢": "Acho que você gosta",
  "订单已完成": "O pedido está concluído",
  "热销推荐": "Recomendação de venda quente",
  "头像选择": "Seleção de Avatar",
  "修改头像": "Modifique seu avatar",
  subOrder: "Enviar pedido",
  "mailboxCheck": "Por favor, preencha o endereço de e-mail correto",
  "switchLang": "Mude para outro idioma para ver",
  "myCart": "meu carrinho de compras",
  "notQua": "As condições de qualificação não são atendidas.",
  "noSmaller": "O valor aplicado não pode ser inferior a",
  "nomax": "O valor máximo da aplicação não pode exceder",
  "evaluationUploading": "Você ainda tem fotos carregando. Por favor, tente novamente mais tarde",
  "evaluateInput": "Revisão com fotos",
  "moneyOrderStatus": "Status do pedido",
  "coinBlock": "Acordo de moeda",
  "dealing": "Em processo",
  "dealSuccess": "Bem-sucedido",
  "dealFail": "Falhar",
  "payCertificate": "Certificado de pagamento",
  "handleFee": "Taxa de serviço",
  "highOpinion": "Boas críticas",
  "mediumOpinion": "Avaliação média",
  "lowOpinion": "Comentários ruins",
  "hasImage": "Com fotos",
  "rechargeMethod": "modo de recarga",
  "scanAndDown": "Digitalize o código QR Baixe o aplicativo",
  "receivedAddress": "endereço de recebimento",
  "ActualLedger": "Recibo real",
  "view": "Visualizar",
  "withdrawNum": "Quantidade de saque em dinheiro",
  "rechargeNum": "Quantidade de recarga",
  "date": "Data",
  "walletHistory": "Histórico da carteira",
  "accountBalance": "Saldo da conta",
  "accountReview": "Visão geral da conta",
  "rated": "Revisado",
  "receiver": "Receptor",
  "orderStatus": "Status",
  "orderTime": "Tempo",
  "tax": "Tributação",
  "discount": "Desconto",
  "productInfo": "Informação do produto",
  "paramError": "Erro de parâmetro",
  "orderInfo": "Informações do pedido",
  "rebuy": "mais um pedido",
  "pleaseCorrectAddress": "Insira o endereço de retirada de dinheiro correto",
  "pleaseInputCorrectNumber": "Por favor insira um número maior que 0",
  "vcodePass": "Verificação aprovada!",
  "vcodeFail": "Autenticação falhou. Por favor, tente novamente",
  "uploading": "Enviando...",
  "uploadSuccess": "Carregado com sucesso",
  "uploadError": "O carregamento falhou. Por favor, tente novamente",
  "registerSuccess": "Registro bem-sucedido",
  "pleaseSetMobileNumber": "Defina o número de telefone",
  "unSelectedProduct": "Você não selecionou um produto",
  "loginSuccess": "Login bem-sucedido",
  "pleaseSetAreaCode": "Insira o nome do país e o código de área para pesquisar",
  "login": "Conecte-se",
  "register": "Cadastro",
  "logout": "Saída",
  "noData": "Nenhum dado encontrado",
  "search": "Procurar",
  "historySearch": "pesquisa histórica",
  "empty": "Vazio",
  "home": "Pagina inicial",
  "favorableRate": "Taxa de boas avaliações",
  "classification": "Categoria",
  "searchTips": "Pesquisa de origem/produto/fornecedor/pedido",
  "dailyNewArrival": "Novos produtos diários listados",
  "more": "Mais",
  "recommend": "Recomendação",
  "recommendedProducts": "Produtos recomendados",
  "recommendedStore": "Lojas recomendadas",
  "buyNow": "Compre agora",
  "addCart": "Adicionar ao Carrinho",
  "complex": "Integrado",
  "price": "Preço",
  "retailPrice": "Preço de varejo",
  "originPrice": "Preço original",
  "service": "Atendimento ao Cliente",
  "collect": "Favoritos",
  "sold": "Volume de vendas",
  "pageviews": "Quantidade de navegação",
  "quantity": "Quantidade",
  "freight": "Carga",
  "shipping": "Envio",
  "ship": "Barco",
  "buyTips": "Enviamos em até 24 horas após fazer o pedido. Os seguintes pedidos estão sob controle logístico e podem ser enviados com atraso. Preste atenção às informações de logística ou entre em contato com o atendimento ao cliente.",
  "totalPrice": "Preço total",
  "addCartMessage": "Adicionado com sucesso ao carrinho de compras",
  "addCartMessageFaild": "O produto já existe no carrinho de compras.",
  "myAccount": "minha qccount",
  "buyHistory": "registros de compra",
  "wishlist": "produtos favoritos",
  "trackOrder": "Ordem",
  "account": "Conta:",
  "sellerZone": "área do comerciante",
  "beSeller": "Torne-se um comerciante",
  "sellerPanelLogin": "Login do comerciante",
  "footTip": "© Copyright {name} Ltda 2024",
  "footTips": "A {name} Limited é autorizada e regulamentada pela Financial Conduct Authority como corretora de crédito (713206) e lida exclusivamente com o credor Home Retail Group CardServices Limited como {name} Financial Services. A {name} Financial Services está autorizada e regulamentada pela Financial Conduct Authority para fornecer crédito (716148). Home Retail GroupCard Services Limited está registrado no Reino Unido (04007072) em Avebury, 489-499 Avebury Boulevard, Milton Keynes, Reino Unido. MK9 2NW.",
  "item": "Artigo",
  "checkout": "Fazer um pedido",
  "productDescription": "Descrição do produto",
  "userEvaluation": "Comentários de usuários",
  "AllProducts": "Todos os produtos",
  "followers": "Seguir",
  "sales": "Volume de vendas",
  "visitStore": "Visite a loja",
  "authentic": "100% genuíno",
  "dayReturns7": "7 dias de retorno",
  "shippingDiscounts": "desconto de frete",
  "safePayment": "Pagamento seguro",
  "followed": "seguido",
  "dashboard": "Painel de instrumentos",
  "myOrder": "Meu pedido",
  "setUp": "Configurar",
  "successTips": "Bem-sucedido",
  "copySuccess": "Replicação bem-sucedida",
  "balance": "Saldo (USDT)",
  "sort": "Tipo",
  "commodity": "produtos",
  "browse": "Volume de vendas",
  "recharge": "Recarrega",
  "commodityCollection": "Coleção de produtos",
  "withdraw": "Retirada de dinheiro",
  "defaultAddress": "Endereço padrão",
  "addNewAddress": "adicionar novo endereço",
  "withdrawRecord": "Registro de saque em dinheiro",
  "serialNumber": "Nº do pedido",
  "time": "Tempo",
  "amount": "Quantia",
  "processing": "Em processo",
  "fail": "Falhar",
  "blockchainNetwork": "Rede Blockchain",
  "records": "Registro",
  "withdrawAddress": "Endereço de saque em dinheiro",
  "withdrawInputTips": "Por favor, insira o endereço de retirada",
  "copy": "Replicação",
  "enterTips": "Por favor, insira",
  "actualAccount": "Conta real",
  "handlingFee": "Taxa de serviço",
  "confirm": "Confirme o recebimento",
  "previous": "Passo anterior",
  "pleaseEnterAddress": "Por favor, insira o endereço",
  "pleaseEnterQuantity": "Por favor, insira a quantidade",
  "withdrawSuccess": "Pedidos enviados com sucesso",
  "saveQr": "Salvar código QR",
  "pleaseEnterAmount": "Por favor, insira o valor da recarga",
  "expectedArrival": "Chegada esperada",
  "currentRate": "Taxa de câmbio atual",
  "uploadTips": "Comprovante de pagamento (Faça o upload da captura de tela com os detalhes do pagamento)",
  "clickUpload": "Clique para carregar",
  "uploadPhoto": "Por favor, envie fotos",
  "rechargeSuccessful": "Recarga bem-sucedida",
  "rechargeTips": "\"Solicitação de recarga: \"\"Por favor, preencha o valor real da transferência com sinceridade. Caso contrário, o sistema pode não passar na aprovação e afetar o andamento da recarga.\"",
  "rechargeRecord": "registro de recarga",
  "all": "Todos",
  "pending": "Ser pago",
  "cancelled": "Cancelado",
  "delivered": "Para ser enviado",
  "confirmed": "Confirmado",
  "receipt": "A ser recebido",
  "harvested": "Recebido",
  "comment": "A ser revisado",
  "refund": "Reembolso/pós-venda",
  "cancelOrder": "Cancelar pedido",
  "cancelReason": "Razão para cancelamento",
  "cancelOrderTitle": "Selecione um motivo de cancelamento do pedido",
  "returnOrderTitle": "Selecione o motivo da devolução",
  "refundInstructions": "Instruções de reembolso",
  "returnDetailTips": "Por favor, dê uma opinião sobre o produto",
  "cancel": "Cancelar pedido",
  "cancelOrder1": "Produto não recebido",
  "cancelOrder2": "Não gosto, não quero",
  "cancelOrder3": "O vendedor enviou a mercadoria errada",
  "cancelOrder4": "marca falsa",
  "cancelOrder5": "Menos remessa, remessa perdida",
  "cancelOrder6": "Produto recebido danificado",
  "cancelOrder7": "Há um problema de qualidade",
  "cancelOrder8": "Negocie o reembolso com o comerciante",
  "cancelOrder9": "Outras razões",
  "cancelOrderSuccess": "Pedido cancelado com sucesso",
  "returnOrderSuccess": "Enviado com sucesso",
  "orderName": "Nome",
  "orderEmail": "E-mail",
  "orderAddress": "Endereço",
  "orderNation": "País",
  "orderState": "Status",
  "orderCity": "Cidade",
  "orderPostCode": "Código postal",
  "orderAmount": "Quantidade",
  "orderPrefix": "Ordem total",
  "orderFee": "impostos",
  "orderSpecification": "Especificação",
  "orderCommodity": "produtos",
  "orderQuantity": "Quantidade",
  "orderUnitprice": "Preço unitário",
  "orderFreight": "Carga",
  "orderTax": "Imposto",
  "orderTotal": "Total",
  "PaymentOrder": "Ordem de pagamento",
  "Evaluate": "Análise",
  "CancelOrder": "Cancelar pedido",
  "RemindShip": "Lembrar para envio",
  "Refund": "Reembolso",
  "Submitareview": "Enviar comentários",
  "Information": "Informação",
  "wrongPassword": "Erro de senha mais de 3 vezes. Por favor, tente novamente amanhã.",
  "Operate": "Operação",
  "Item": "Unid)",
  "From": "De",
  "hint": "Pontas",
  "CheckDetails": "Ver detalhes",
  "Payment": "Pagamento",
  "Cancel": "Cancelar",
  "refundSuccessfully": "Reembolso bem-sucedido",
  "pendingPayment": "Ser pago",
  "pay": "Pagamento",
  "LoginPassword": "Senha de login",
  "sure": "Claro",
  "shippingAddress": "Endereço de recebimento",
  "pleaseAddShippingAddress": "Por favor, adicione um endereço de entrega primeiro",
  "transactionPassword": "senha da transação",
  "markDefaultAddress": "Marcar como endereço de entrega padrão",
  "edit": "Editado por",
  "delete": "Excluir",
  "Opt": "Selecione",
  "piece": "pcs",
  "orderDetails": "Detalhes do pedido",
  "shopCollection": "Adicionar a loja aos favoritos",
  "addAddress": "adicionar novo endereço",
  "signUp": "Cadastro",
  "loginTips": "já tem uma conta?",
  "loginIn": "Conecte-se",
  "mobile": "Telefone não",
  '购物车还没有商品': "O carrinho de compras ainda não tem produtos",
  '去购物': "Vá às compras",
  "modifyAddress": "Modificar endereço",
  "desc": "Definir como endereço padrão",
  "keep": "Manter",
  "onlineService": "Serviços online",
  "send": "Enviar",
  "EsShop": "Loja online",
  "desc3": "Digite a senha da transação",
  "desc4": "Digite sua senha de transação",
  "desc6": "Digite sua senha de transação novamente",
  "setUpPayPaw": "Definir senha da transação",
  "setSuccess": "Configuração bem-sucedida",
  "confirmPayPaw": "Confirme a senha da transação",
  "paymentSuccessful": "Pagamento bem-sucedido",
  "paymentPending": "Pagamento pendente",
  "paymentPendingDesc": "Seu pagamento está sendo processado. Por favor, verifique o status do seu pedido mais tarde",
  "desc5": "Endereço de entrega errado? Contato",
  "customeService": "Atendimento ao cliente on-line",
  "BackHome": "Voltar à página inicial",
  "Checkorder": "Ver pedido",
  "ForgotPassword": "Esqueceu a senha?",
  "signIn": "Conecte-se",
  "noAccount": "Sem número de conta?",
  "pleaseEnterAccount": "Insira o número da conta",
  "pleaseEnterPassword": "Por favor, digite a senha",
  "password": "Senha",
  "mobilePhone": "Número de telefone",
  "pleaseEnterPhoneNumer": "Defina o número de telefone",
  "setPassword": "Configurar senha",
  "noDataFound": "Nenhum dado encontrado",
  "searchCountry": "Insira o nome do país e o código de área para pesquisar",
  "pleaseEnterEmail": "Defina a caixa de correio",
  "invitationCode": "Código de Convite",
  "plaeseEnterInvitaionCode": "Defina o código de convite",
  "pleaseSetLoginPassword": "Por favor, defina a senha de login",
  "selectDeliveryAddress": "Selecione o endereço de entrega",
  "totalOf": "Total",
  "items": "Item",
  "orderSummary": "Resumo do pedido",
  "paymentMethod": "Forma de pagamento",
  "Balance": "Equilíbrio",
  "payPal": "PayPal",
  "notOpen": "Este método de pagamento ainda não está disponível para sua região",
  "mastercard": "MasterCard",
  "additional": "Extra",
  "handlingfee": "Taxa de serviço necessária",
  "goodsNumber": "quantidade de produtos",
  "deliveryFee": "frete",
  "totalNum": "Total",
  "new": "Novo",
  "oldPassword": "Senha Antiga",
  "pleaseEnterOldPassword": "Por favor, digite a senha antiga",
  "newPassword": "Nova Senha",
  "plaseeEnterNewPassword": "Por favor, digite a nova senha",
  "confirmPassword": "Confirme sua senha",
  "plaseeENterConfirmPassword": "Por favor, digite a senha de confirmação",
  "twoPawword": "Duas senhas não são iguais",
  "rechargeAddress": "endereço de recarga",
  "plaseEnterRechargeAddress": "Por favor, insira o endereço de recarga",
  "userCenter": "centro pessoal",
  "merchantSettled": "entrada do comerciante",
  "upNew": "Novo produto listado",
  "balanceNot": "O equilíbrio não é suficiente. Por favor, recarregue.",
  "NoProductSelected": "Produto ainda não selecionado",
  "ShippingAddressNotSet": "Endereço de entrega não definido",
  "consigneeName": "Nome do destinatário",
  "email": "E-mail:",
  "areaCode": "Código de área internacional",
  "phoneNumber": "Número de telefone",
  "nation": "País",
  "state": "Província/Estado/Estado",
  "city": "Cidade",
  "postCode": "Código postal",
  "address": "Endereço detalhado",
  "addAddressOrModifyAddress": "Adicionar novo endereço/Modificar endereço",
  "setAsTheDefaultAddress": "Definir como endereço padrão",
  "proceed": "Continuar",
  "btnSure": "confirme",
  "pleaseInput": "Por favor, insira",
  "allProduct": "Todos os produtos",
  "myCommodityCollection": "produtos favoritos",
  "myFollowedShops": "Siga a loja",
  "mySold": "Vendido",
  "myPageviews": "Quantidade de navegação",
  "myPraiseRate": "Taxa de boas avaliações",
  "myUnfollow": "Deixar de seguir",
  "inputNum": "Números",
  "inpuEmailErro": "Por favor, insira o endereço de e-mail correto",
  "goodsShip": "envio",
  "goodsShipTips": "Os produtos serão enviados em até 24 horas após o pedido. Se houver controle de logística para o pedido seguinte, o pedido poderá atrasar. Preste atenção às informações de logística do pedido ou entre em contato com o atendimento ao cliente.",
  "goodsFreight": "frete",
  "goodsFreeShipping": "Grátis",
  "goodsFreightTips1": "1. Composição do frete de produtos transfronteiriços: frete=taxa de despacho+frete de longa distância+taxa de entrega",
  "goodsFreightTips2": "2. Se as condições de postagem não forem atendidas, o frete será cobrado de acordo com as condições reais.",
  "goodsFreightTips3": "3. O direito de interpretação final pertence à plataforma.",
  "pleaseValidPostCode": "Insira mais de 4 dígitos",
  "pleaseValidEmail": "Por favor, insira o endereço de e-mail correto",
  "pleaseValidPhone": "Por favor, insira o número de telefone correto",
  "productAvailable": "Este produto foi removido",
  "validatorMaxNumber": "Valor excede o limite",
  "validatorRequire": "Os itens obrigatórios não podem ser nulos",
  "validatorPhone": "Por favor, insira o número de telefone correto",
  "validatorEmail": "Insira o formato de e-mail correto",
  "validatorPassword": "A senha é composta de 6 a 12 dígitos ou letras(contém caracteres especiais)",
  "validatorSixNumber": "Insira 6 dígitos puros",
  "加值": "Valor adicional",
  "提领": "Retirada",
  "银行卡": "Cartão bancário",
  "平台人工发起退款": "Reembolso iniciado manualmente pela plataforma",
  "联系商家": "Contate o comerciante",
  "validatorFourMoreNumber": "Insira uma combinação de 4 a 32 dígitos ou letras",
  "validatorIpRule": "Formato de IP incorreto",
  "validatorChineseAndEnglish": "Somente chinês e inglês, digite o intervalo: 8-64 caracteres",
  "collectionSuccess": "Adicionar aos favoritos com sucesso",
  "followedSuccess": "Seguir com sucesso",
  "cancelSuccess": "Cancelado com sucesso",
  "evaluateOrder": "Revisão com fotos",
  "evaluateOrderPlaceholder": "Por favor, revise os produtos",
  "operationSuccess": "Operação bem-sucedida",
  "confirmReceiveGoods": "Confirme o recebimento do produto ou não",
  "evaluateOrderSuccess": "Revisão bem-sucedida",
  "yesterday": "Ontem",
  "notLogin": "Você ainda não fez login.",
  "delAllHistoryRecord": "Tem certeza de que deseja excluir todos os registros do histórico?",
  "or": "Ou",
  "tipsRemindsText": "O comerciante receberá um lembrete após a remessa ser lembrada",
  "tipsRemindsCount": "Só pode ser lembrado uma vez.",
  "tipsRemindsMerchant": "Lembrar comerciantes",
  "tipsRemindsSuccess": "Lembrete bem-sucedido",
  "noCartTips": "O seu saco de compras está vazio. Comece a fazer compras.",
  "defaultRate": "O sistema padroniza para avaliações favoráveis",
  "prevPage": "Página anterior",
  "nextPage": "Próxima página",
  "returnApply": "Solicitação de reembolso",
  "returnReason": "Motivo do reembolso",
  "returnAmount": "Valor devolvido",
  "returnRemark": "Instruções de devolução",
  order: {
    confirm: "Confirme o recebimento",
    canel: "Cancelar pedido",
    payment: "Pague agora",
    remind: "Lembrar para envio",
    return: "Solicitação de reembolso do produto",
    evaluate: "Avalie agora",
    logistics: "Ver logística",
    noRefund: "Não reembolsado",
    refunding: "Reembolso em andamento",
    refundSuccess: "Reembolso bem-sucedido",
    refundFail: "Falha no reembolso",
  },
  "remindTitle": "Lembrar para envio",
  "remindContent": "Após o envio ser lembrado, o comerciante receberá o lembrete. Só pode ser lembrado uma vez.",
  "remindSuccess": "Lembrete bem-sucedido",
  "remindRepeat": "Este pedido foi lembrado.",
  "noComments": "Sem avaliação no momento",
  "storeSeach": "Procurar produto nesta loja",
  "storeSeachTips1": "Encontrado para você",
  "storeSeachTips2": "Lojas relacionadas encontradas",
  "storeSeachTips3": "Lar",
  "creditTit": "serviços de crédito",
  "getCoupons": "Obtenha mais cupons",
  "yourEmail": "Seu endereço de email",
  "subscription": "Assinaturas",
  "paymethods": "Forma de pagamento",
  "footdec": "Os usuários do site global {name} vêm de {num} países ao redor do mundo e usam {coin} para liquidação. {coin} é uma transação sem fronteiras que permite transações imediatas e de baixo custo em todo o mundo, sem espera e taxas internacionais.",
  "custService": "Atendimento ao Cliente",
  "helpLine": "Atendimento ao cliente on-line",
  "contactUs": "Contate-nos",
  "partner": "Fornecedores cooperativos",
  "客户端下载":
    "Download para clientes",
  "buyRules": "Regras do comprador",
  "提现方式":
    "Formas de transferência",
  "sellerRules": "política do vendedor",
  "returnsAndEx": "Devoluções e trocas",
  "servicePolicy": "política de serviço",
  "returnPolicy": "Política de devolução",
  "user_Center": "centro do usuário",
  "userReg": "Registro do usuário",
  "orderTrack": "consulta de pedido",
  "purchageHistory": "Histórico de compras",
  "myPurse": "Minha carteira",
  "aboutUs": "Sobre nós",
  "Recruitment": "Espere por pessoas talentosas",
  "news": "informações de notícias",
  "stateMent": "declaração de escravidão moderna",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "okx",
  "metaMask": "MetaMask",
  "homeBannertips1": "Torne-se um comerciante",
  "homeBannertips2": "Comissão total",
  "homeBannertips3": "máx.",
  "homeBannerbtn": "Entrar",
  "homeDownloadtips1": "Shopping atacadista de comércio eletrônico transfronteiriço",
  "homeDownloadtips2": "Oferta especial da marca",
  "homeDownloadtips3": "Desconto contínuo",
  "homeDownloadtips4": "Baixar Android",
  "homeDownloadtips5": "Baixar Apple",
  "homeDownloadtips6": "Escaneie o código QR para baixar o APP",
  "homeIconTips1": "100% genuíno",
  "homeIconTips2": "7 dias de retorno",
  "homeIconTips3": "desconto de frete",
  "homeIconTips4": "pagamento seguro",
  "headerSearchTips": "Por favor, insira a palavra-chave para pesquisar",
  "collAccount": "Modo de empréstimo",
  "mine": "Meu.",
  "creditText1": "Empréstimos para startups resolvem o problema de pedir dinheiro emprestado",
  "creditText2": "Fornecer serviços de empréstimo inicial e giro de capital",
  "creditWorry": "Empréstimo sem preocupações",
  "creditQuota": "limite flexível",
  "creditQuotaINFO": "100.000 a 30.000.000 com limite flexível e sem restrições, com prazo máximo de empréstimo de um ano.",
  "quickLoan": "Empréstimo rápido",
  "creditReview": "Passe na auditoria em no mínimo uma hora, se a revisão for aprovada, o empréstimo será liberado imediatamente.",
  "safe": "Seguro e sem preocupações",
  "safeInfo": "Sem hipoteca, sem depósito, sem chamada de volta, pois este é realmente um assunto privado.",
  "about": "Sobre nós",
  "aboutText1": "\"Estamos comprometidos com serviços financeiros de empréstimo, com base na filosofia de negócios \"\"cliente em primeiro lugar\"\", com a missão de resolver o problema de rotatividade de capital do cliente. Desde a sua criação, a empresa ajudou vários clientes a resolver o problema da rotatividade de capital.\"",
  "aboutText2": "Limite: 100.000-30.000.000, método de pagamento flexível com juros baixos, sem taxa inicial, empréstimo online, sem telefonema para verificação, informações confidenciais e empréstimo no mesmo dia.",
  "contactUs1": "Se você não quiser pedir dinheiro emprestado de seus colegas de nível, entre em contato conosco.",
  "committed": "Compromisso com os serviços de empréstimo para empreendedores",
  "financial": "Aborde suas preocupações financeiras",
  "partnersTit": "Plataforma de empréstimos on-line para parceiros",
  "application": "Solicitação de empréstimo",
  "applicant": "Candidato",
  "actualName": "Nome real",
  "yourName": "Por favor, digite o nome",
  "term": "Termo de empréstimo",
  "applicationAmount": "Valor solicitado",
  "rates": "Taxa de juros do empréstimo",
  "loanMethod": "Modo de empréstimo",
  "accountB": "Saldo da conta",
  "countryOf": "Nacionalidade",
  "myloan": "meu empréstimo",
  "applyLoan": "Aplicar para um emprestimo",
  "loaned": "Emprestado",
  "interest": "Juros acumulados",
  "esRepayment": "Reembolso estimado",
  "loanHistory": "registro de empréstimo",
  "applicantDate": "Data de aplicação",
  "repayment": "Reembolso",
  "cycle": "Ciclo de reembolso",
  "fixedRate": "Taxa de juros fixa",
  "successLoan": "Empréstimo bem-sucedido",
  "Reapply": "Reaplicar",
  "borrow": "Empréstimo falhou",
  "applicantIn": "Aplicação em andamento",
  "repaid": "Reembolso",
  "overdue": "Atrasado",
  "estirepay": "Reembolso estimado",
  "loanDays": "Número de dias emprestado",
  "reAmount": "Valor do reembolso",
  "repay": "Modo de reembolso",
  "entRepay": "Confirmar reembolso",
  "foryourmoney": "Se você está com falta de fundos, não encontra onde pedir dinheiro emprestado ou tem vergonha de pedir dinheiro emprestado a seus amigos, entre em contato conosco. Temos todo o processo de atendimento profissional para tirar suas dúvidas a qualquer momento. Nosso objetivo é tornar cada empréstimo transparente, para que os clientes possam usá-lo com rapidez e confiança.",
  "onlineApplin": "Inscreva-se on-line",
  "businessloan": "Pedido de empréstimo para startup",
  "selectCountry": "Selecione uma nacionalidade",
  "selectPeriod": "Selecione um período",
  "passPortImg": "N.º de ID/N.º do Passaporte",
  "uploadId": "Carregamento de foto do certificado/passaporte",
  "readAndAgree": "eu li e concordo",
  "loanAgree": "Contrato de empréstimo",
  "submitApplica": "Envio de candidatura",
  "photoExample": "Exemplo de tirar fotos",
  "discounted": "produtos com desconto",
  "days": "dia",
  "privacyPolicy": "Política de Privacidade",
  "delivery": "Entrega e retirada",
  "checkAgreement": "Marque o acordo!",
  "businessPhone": "Telefone comercial",
  "businessEmail": "Email Corporativo",
  "提交失败": "Falha no envio",
  "充值金额不能小于1": "O valor da recarga não pode ser inferior a 1 (incluindo duas casas decimais)",
  "请切换其他语言后查看": "Mude para outro idioma para ver",
  "我的购物车": "meu carrinho de compras",
  "推荐商品": "Produtos recomendados",
  "猜你喜欢": "Acho que você gosta.",
  "暂无店铺": "Nenhuma loja encontrada",
  "添加失败": "Falha ao enviar. Por favor, tente novamente mais tarde",
  "提交订单": "Envio de pedido",
  recommendclass: "Recomendado",
  "滑动验证": "Verificação de deslizamento",
  "最多上传9张图片": "No máximo 9 fotos",
  "账号注销": "Conta cancelada",
  "确定注销": "Confirmar cancelamento",
  "您的账号": "Sua conta",
  "为什么要离开": "Por que você está deixando?",
  "您还有余额,不能注销账号": "Você ainda tem saldo, não pode cancelar a conta!",
  "请输入注销理由": "Por favor, digite o motivo do cancelamento",
  "您确认要注销吗?": "Você tem certeza que deseja cancelar?",
  "我再考虑下": "Eu vou pensar mais",
  "同意注销": "Concordo em cancelar",
  "注销成功": "Cancelamento bem-sucedido",
  // "暂无店铺": "Nenhuma loja encontrada",
  "App下载(买家端)": "Download do aplicativo (comprador)",
  "企业电话": "Telefone corporativo",
  "职业机会": "Oportunidade de carreira",
  "长时间未付款，系统自动取消订单": "O pedido será cancelado automaticamente se não for pago por um longo tempo",
  "最多包含10位小数": "No máximo 10 casas decimais",
  "App下载(卖家端)": "Download do aplicativo (vendedor)",
  "加密货币": "Moeda criptografada",
  "银行卡": "Cartão bancário",
  "充值币种": "Moeda de recarga",
  "充值金额": "Valor da recarga",
  '参数缺失': "Parâmetro ausente",
  '充值数量必填': "O número de recargas é obrigatório",
  "充值金额不得小于": "O valor da recarga não pode ser inferior a",
  "充值金额不得大于": "O valor da recarga não pode ser superior a",
  "请先选择币种": "Por favor, selecione a moeda primeiro",
  "开户行": "Banco",
  "请输入开户行名称": "Por favor, digite o nome do banco",
  "银行卡号": "Número do cartão bancário",
  "请输入银行卡号": "Por favor, digite o número do cartão bancário",
  "点击去支付": "Clique para pagar",
  "企业证明": "Prova empresarial",
  footTipTikTok:'CoveBuy ©️2024 Direitos autorais',
  TikTokFoot:'O CoveBuy é uma plataforma social global de vídeos curtos CoveBuy e a maior empresa de comércio atacadista da Ásia, Alibaba, estabelecida em cooperação. É uma plataforma global de comércio eletrônico e possui três armazéns inteligentes autogeridos no mundo, localizados em Toronto, Canadá, Los Angeles e Chiba, Japão. Os produtos à venda no aplicativo incluem produtos populares do Japão, Coreia do Sul, China e outros países asiáticos. Atualmente, o número total ultrapassou 50.000 e continua a crescer rapidamente.',
  "cancelInfo":"avisar! Por favor, tenha cuidado ao cancelar a conta. Se você não usar mais a conta, você pode clicar em [Concordar com o cancelamento]. Você pode não conseguir se registrar dentro de alguns dias após o cancelamento.",
  "betaBannerText": "O site está em teste público, por favor não faça pedidos"
}